import {GetMetaTable} from "../TableComponents/utils/table_helpers"
import Dropdown from "../Dropdown/Dropdown"
import PropTypes from "prop-types"
import React from "react"

export default function ContagiousDropdown(props){
	const metaTable = GetMetaTable(props.reportType)
	
	const dropdownOptions = []
	
	for(let i = 0; i < metaTable.length; i++){
		const attribute = metaTable[i]
		
		if(attribute.contagious){
			dropdownOptions.push({
				value: attribute.name,
				display: attribute.displayText ?? attribute.headerText
			})
		}
	}
	
	if(dropdownOptions.length === 0 ){
		return null
	}
	
	return (
		<Dropdown
			initialValue={dropdownOptions[0].value}
			options={dropdownOptions}
			onChangeCallback={props.changeFilterAttribute}
		/>
	)
}

ContagiousDropdown.propTypes = {
	reportType: PropTypes.string.isRequired,
	changeFilterAttribute: PropTypes.func.isRequired
}